export default __webpack_public_path__ + "static/media/slice-video.0c7f4533.m4v";